import { useEffect, useState } from 'react';

import { Button } from '@repo/videa-components/src/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@repo/videa-components/src/ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@repo/videa-components/src/ui/select';

export interface ProviderSelectionDialogProvider {
  pmsId: string;
  firstName: string;
  lastName: string;
}

export interface ProviderSelectionDialogProps {
  open: boolean;
  providers: ProviderSelectionDialogProvider[];
  onConfirm: (providerPmsId: string) => void;
  onCancel: () => void;
}

export const ProviderSelectionDialog = ({
  open,
  providers,
  onConfirm,
  onCancel,
}: ProviderSelectionDialogProps) => {
  const [selectedProviderPmsId, setSelectedProviderPmsId] = useState<string>('');

  useEffect(() => {
    if (open) {
      setSelectedProviderPmsId('');
    }
  }, [open]);

  const handleConfirm = () => {
    if (selectedProviderPmsId) {
      onConfirm(selectedProviderPmsId);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <DialogContent className="vai-font-inter vai-z-[10001] vai-max-w-md" hideClose>
        <DialogHeader>
          <DialogTitle>Select Provider</DialogTitle>
          <DialogDescription>
            A provider is required to save this note to your PMS. Please select
            the provider for this visit.
          </DialogDescription>
        </DialogHeader>

        <div className="vai-py-2">
          <Select
            value={selectedProviderPmsId}
            onValueChange={setSelectedProviderPmsId}
          >
            <SelectTrigger>
              <SelectValue placeholder="Select a provider" />
            </SelectTrigger>
            <SelectContent className="vai-z-[10002]">
              {providers.map((provider) => (
                <SelectItem key={provider.pmsId} value={provider.pmsId}>
                  {provider.firstName} {provider.lastName}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={!selectedProviderPmsId}
          >
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
